/**
 * RENOV SEM PRODUTO NOVO NÃO EXISTE (Douglas 06/10/2026: "não existe criar prévia sem
 * venda nova... nenhum pedido pode ir sem produto novo. Ela reduz pra colocar novo").
 * Produto novo: linha que vem de outra operadora, linha nova, TV ou ponto, fibra nova.
 * Renovar as linhas e trocar o pacote da fibra que ele já tem não contam.
 */
export function renovSemProdutoNovo(tipoLead: string | null | undefined, itens: any[]): string | null {
  if (String(tipoLead ?? '').toUpperCase() !== 'RENOVACAO_CPF') return null;
  const novo = itens.some((i) => {
    const tipo = String(i?.tipo ?? '').toUpperCase();
    if (['PORTABILIDADE', 'NOVA', 'LINHA_NOVA', 'TV'].includes(tipo)) return true;
    return tipo === 'FIBRA' && !String(i?.plano_codigo ?? '').endsWith('-migra');
  });
  return novo ? null
    : 'Renovação sem produto novo não existe: a proposta só renova as linhas e troca o pacote, e isso é só desconto. '
      + 'Monte com proposta_pronta (ler_venda_cpf), que já traz o produto novo (TV, ponto, linha nova ou fibra nova).';
}
